import React, { useEffect, useState } from "react";
import Hero from "../../components/Hero";
import Banner from "../../components/Banner";
import { Link } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const Tubular = () => {
  const [packages, setPackages] = useState([]);
  useEffect(() => {
    const getData = async (e) => {
      let topList = [];
      const q = query(
        collection(db, "Packages"),
        where("batteryType", "==", "Tubular")
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        topList.push({ id: doc.id, ...doc.data() });
      });
      setPackages(topList);
    };
    getData();
  }, []);
  // console.log(packages);
  return (
    <div>
      <br />
      <Hero hero="roomsHerot">
        <Banner title="Tubular Battery Promo Packages">
          <Link to="/packages" className="btn-primary">
            Return to packages
          </Link>
        </Banner>
      </Hero>
      <br /> <br />
      <header className="section-header">
        <h3>Explore our Tubular Battery Packages</h3>
        <div className="divider"></div>
        {/* <p>
          Our special anniversary discounts on our Tubular packages are back
          based on popular demand, but only for a limited time! Don’t miss this
          opportunity to save big.
        </p> */}
      </header>
      <section className="package-container">
        <div className="overview-content">
          <ul className="features-list">
            {packages.map((item, index) => (
              <li key={index}>
                <Link to={"/packages/" + item.id}>
                  <span>{item.packages}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <br />
      </section>
    </div>
  );
};

export default Tubular;
